var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Input, InputGroup, InputRightElement, FormLabel, } from '@chakra-ui/react';
import { useState, useEffect, } from 'react';
import moment from 'moment';
import { CalendarIcon, ClearIcon } from '../icons';
import { useAutoDateFormatter } from '../../../hooks/useAutoDateFormatter';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { rem } from 'polished';
import { customDatePickerStyles } from './picker-styles';
export const DatePickerInput = (_a) => {
    var _b, _c, _d, _e;
    var { isError, dateString = undefined, controlName, colors, onDateChange, placeholder, dateFormat = 'YYYY-MM-DD', onBlurEvent, maxDateString, minDateString, alwaysPassChange = false, sx, _invalid, variant = 'outline', mask, rightElement = undefined, isClearable = false, label } = _a, props = __rest(_a, ["isError", "dateString", "controlName", "colors", "onDateChange", "placeholder", "dateFormat", "onBlurEvent", "maxDateString", "minDateString", "alwaysPassChange", "sx", "_invalid", "variant", "mask", "rightElement", "isClearable", "label"]);
    const [value, setValue] = useState('');
    const { formattedInput, handleInputDate } = useAutoDateFormatter();
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    // icon component
    const Calendar = CalendarIcon({ isError });
    const Clear = ClearIcon();
    const handleChange = (item) => {
        if (!item) {
            return;
        }
        const formattedDate = moment(item, 'YYYY-MM-DD').format(dateFormat);
        handleInputDate(formattedDate, dateFormat);
        setValue(formattedDate);
    };
    const formatMinMaxDate = (date) => {
        const formattedDate = moment(date, dateFormat).format('YYYY-MM-DD');
        const temp = new Date(+new Date(formattedDate));
        return moment(temp).format('YYYY-MM-DD');
    };
    // handle empty dateString
    useEffect(() => {
        if ((dateString === null || dateString === void 0 ? void 0 : dateString.length) === 10) {
            const dateFormatted = moment(dateString, 'YYYY-MM-DD').format(dateFormat);
            handleInputDate(dateFormatted, dateFormat);
            setValue(dateFormatted);
        }
        else if (dateString === '') {
            setValue('');
        }
    }, [dateString, dateFormat]);
    const onUserInputChange = (item) => {
        setValue(item.target.value);
        handleInputDate(item.target.value, dateFormat);
        if (alwaysPassChange) {
            onDateChange(item.target.value);
        }
    };
    useEffect(() => {
        setValue(formattedInput);
        if (formattedInput.length === 10) {
            const formattedDate = moment(formattedInput, dateFormat).format('YYYY-MM-DD');
            onDateChange(formattedDate);
        }
    }, [formattedInput]);
    const onBlurHandle = (e) => {
        setIsCalendarOpen(false);
        if (onBlurEvent) {
            onBlurEvent(e);
        }
    };
    return (_jsxs(InputGroup, Object.assign({ position: "relative", display: "flex", flexDirection: "column", isolation: "auto" }, { children: [_jsx("style", { children: customDatePickerStyles(colors) }), label && (_jsx(FormLabel, Object.assign({ htmlFor: `${controlName}-view`, mb: 1 }, { children: label }))), _jsx(Input, Object.assign({}, props, { placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : dateFormat, value: value, variant: variant !== null && variant !== void 0 ? variant : 'outline', rounded: variant === 'outline' ? 'full' : 'none', lineHeight: rem(24), py: variant === 'outline' ? rem(28) : 0, px: variant === 'outline' ? rem(24) : 0, color: isError ? 'error' : (_b = colors === null || colors === void 0 ? void 0 : colors.textColor) !== null && _b !== void 0 ? _b : 'text', id: `${controlName}-view`, name: `${controlName}-view`, isInvalid: isError, onChange: (e) => onUserInputChange(e), onBlur: (e) => {
                    onBlurHandle(e);
                }, className: mask !== null && mask !== void 0 ? mask : '', "aria-label": (_c = label !== null && label !== void 0 ? label : placeholder) !== null && _c !== void 0 ? _c : 'Date picker' }, { sx, _invalid })), _jsx(DatePicker, { isOpen: isCalendarOpen, onCalendarClose: () => setIsCalendarOpen(false), onChange: (date) => handleChange(date), yearAriaLabel: "YYYY", monthAriaLabel: "MM", dayAriaLabel: "DD", nativeInputAriaLabel: "Date", value: value && moment(value, dateFormat).isValid()
                    ? moment(value, dateFormat).format('YYYY-MM-DD').toString()
                    : '', maxDate: maxDateString
                    ? new Date(formatMinMaxDate(maxDateString))
                    : undefined, minDate: minDateString
                    ? new Date(formatMinMaxDate(minDateString))
                    : undefined, id: `${controlName}-picker`, calendarAriaLabel: "Toggle calendar", clearIcon: null, className: "react-date-picker", locale: "en-GB", format: "yyyy-MM-dd", "aria-label": (_d = label !== null && label !== void 0 ? label : placeholder) !== null && _d !== void 0 ? _d : 'Date picker' }), _jsx(InputRightElement, Object.assign({ mt: variant === 'outline' ? rem(8) : 0, mr: variant === 'outline' ? rem(24) : 0, cursor: props.isDisabled ? 'not-allowed' : 'pointer', sx: rightElement === null || rightElement === void 0 ? void 0 : rightElement.sx, alignItems: "center", justifyContent: "center", w: rem(70) }, { children: _jsxs(Flex, Object.assign({ w: "inherit", justifyContent: "space-evenly", alignItems: "center" }, { children: [_jsx(Flex, Object.assign({ boxSize: rem(20) }, { children: isClearable && value && moment(value, dateFormat).isValid() && _jsx(Clear, { mt: rem(2), mr: rem(12), onClick: () => [setValue(""), onDateChange("")], boxSize: rem(20) }) })), _jsx(Calendar, Object.assign({ stroke: (_e = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _e !== void 0 ? _e : 'text', onClick: () => props.isDisabled
                                ? undefined
                                : setIsCalendarOpen((isCalendarOpen) => !isCalendarOpen), boxSize: rem(17) }, (props.isDisabled && {
                            opacity: 0.5,
                        })))] })) }))] })));
};
//# sourceMappingURL=DatePicker.js.map